import React from 'react'
import { injectIntl } from 'react-intl'

export const IntlContext = React.createContext<any>({} as any)

export const InjectIntlContext = injectIntl(({ intl, children }) => {
  return <IntlContext.Provider value={intl}>{children}</IntlContext.Provider>
})
